module.exports = __webpack_public_path__ + "media/home/OrderingTools-1924edf9.jpg";